module.exports = __webpack_public_path__ + "static/media/country_mn.e1da0eff.webp";